import type { ThemeUnit } from "../../types";
import { pxToUnit } from "../utils";

export const createShadow = (unit: ThemeUnit) =>
  ({
    none: "none",
    sm: `0 ${pxToUnit(1, unit)} ${pxToUnit(2, unit)} rgba(0, 0, 0, 0.05)`,
    md: `0 ${pxToUnit(4, unit)} ${pxToUnit(6, unit)} rgba(0, 0, 0, 0.1)`,
    lg: `0 ${pxToUnit(10, unit)} ${pxToUnit(15, unit)} rgba(0, 0, 0, 0.1)`,
    xl: `0 ${pxToUnit(20, unit)} ${pxToUnit(25, unit)} rgba(0, 0, 0, 0.15)`,
  }) as const;

export const shadowRem = createShadow("rem");
